import { computed, type Ref } from 'vue';
import type { Payout, PayoutEntry } from '@/entities/Entities';

// eslint-disable-next-line import/prefer-default-export
export function calculateSelectedPayoutStatistics(payouts: Ref<Payout[]>) {
  const reducerFnEntry = (acc: number, entry: PayoutEntry) => acc + entry.amount;
  const reducerFn = (acc: number, payout: Payout) => acc + (payout.paymentAmount ?? 0);

  const status = ['pending', 'inPayment', 'payed', 'error'];
  const types = ['week', 'reward', 'box', 'manual', 'credit', 'debt', 'depot'];
  const rewardTypes = [1, 2, 3];

  const selectedPayoutStatistics = computed(() => ({
    perStatus: Object.fromEntries(
      status.map((statusKind) => [
        statusKind,
        payouts.value.filter((payout) => payout.status === statusKind).reduce(reducerFn, 0),
      ]),
    ),
    perType: Object.fromEntries(
      types.map((type) => [
        type,
        payouts.value.reduce(
          (acc: number, payout: Payout) =>
            acc +
            (payout.entries
              ?.filter((entry: PayoutEntry) => entry.type === type)
              .reduce(reducerFnEntry, 0) ?? 0),
          0,
        ),
      ]),
    ),
    perRewardType: Object.fromEntries(
      rewardTypes.map((type) => [
        type,
        payouts.value.reduce(
          (acc: number, payout: Payout) =>
            acc +
            (payout.entries
              ?.filter((entry: PayoutEntry) => entry.type === 'reward' && entry.subType === type)
              .reduce(reducerFnEntry, 0) ?? 0),
          0,
        ),
      ]),
    ),
    total: payouts.value.reduce(reducerFn, 0),
  }));

  return selectedPayoutStatistics;
}
